import { defineApiActionTypes } from 'store/common/action-helpers';

const prefix = 'features/admin/companies/team-members';

export const FETCH_COMPANY_TEAM_MEMBER_CONNECTIONS_FOR_ADMIN_BY_PRETTY_ID = defineApiActionTypes(
  `${prefix}/FETCH_CONNECTIONS_FOR_ADMIN_BY_PRETTY_ID`
);

export const INVITE_TEAM_MEMBER_TO_COMPANY = defineApiActionTypes(`${prefix}/INVITE`);

export const DELETE_TEAM_MEMBER_FROM_COMPANY = defineApiActionTypes(`${prefix}/DELETE`);

export const UPDATE_TEAM_MEMBER_TO_COMPANY = defineApiActionTypes(`${prefix}/UPDATE`);



// WEBPACK FOOTER //
// ./src/store/features/admin/companies/team-members/action-types.js